import { createContext, Dispatch, SetStateAction } from 'react';
import { ICheckoutRequestBody } from '@/api/[bu]/orders/route';

export interface BillingAndShippingForm {
	showCustomAddressForm: boolean;
	radioSelection: null | string;
}

export interface OrderContextState {
	data: ICheckoutRequestBody;

	purchaseOrderNumber?: string;
	setPurchaseOrderNumber: Dispatch<SetStateAction<string>>;

	requestedDeliveryDate: string;
	setRequestedDeliveryDate: Dispatch<SetStateAction<string>>;

	billingForm: BillingAndShippingForm;
	setBillingForm: Dispatch<SetStateAction<BillingAndShippingForm>>;

	shippingForm: BillingAndShippingForm;
	setShippingForm: Dispatch<SetStateAction<BillingAndShippingForm>>;
}

export const initialBillingAndShippingForm = {
	showCustomAddressForm: false,
	radioSelection: null,
};

export const initialCheckoutData: ICheckoutRequestBody = {
	billingAddress: {
		id: '',
		country: '',
		additionalStreetInfo: '',
		city: '',
		postalCode: '',
		streetName: '',
		streetNumber: '',
		region: '',
		businessUnit: '',
	},
	shippingAddress: {
		country: '',
		additionalStreetInfo: '',
		city: '',
		postalCode: '',
		streetName: '',
		streetNumber: '',
		region: '',
	},
	purchaseOrderNumber: '',
};
export const OrderContext = createContext<OrderContextState>({
	data: initialCheckoutData,
	purchaseOrderNumber: '',
	setPurchaseOrderNumber: () => '',
	requestedDeliveryDate: '',
	setRequestedDeliveryDate: () => '',

	billingForm: {
		showCustomAddressForm: false,
		radioSelection: null,
	},
	setBillingForm: () => '',

	shippingForm: {
		showCustomAddressForm: false,
		radioSelection: null,
	},
	setShippingForm: () => '',
});
